// extracted by css-extract-rspack-plugin
export default {"icon":"icon--fbP0u0tIEBMNwpY9","wrapper":"wrapper--kqcUMi7IS6ckWLD0","oneRow":"one-row--foVfMGB8hoP7zkTb"};